import { useContext } from "react";
import { ActionContext } from "./ActionProvider";

export const useActionContext = () => useContext(ActionContext);

export default useActionContext;
